import { Component, Inject, OnInit } from '@angular/core';
import { IncidentType } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-incident-ttype-dialog',
  templateUrl: './edit-incident-ttype-dialog.component.html',
  styleUrls: ['./edit-incident-ttype-dialog.component.css']
})
export class EditIncidentTtypeDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<EditIncidentTtypeDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    selectedName:string="";
    selectedDescription:string="";
    incidentList:IncidentType[]=[];


    ngOnInit() {
      this.getincidenttypelist();
    }
    DialogClose(){
      this.dialogRef.close(false)
    }
  
    editIncident(){
  
      let model= new IncidentType()
      model.Name=this.selectedName;
      model.Description=this.selectedDescription
      model.Active=this.data.active
      model.ID=this.data.IncId
      model.TRIFR=this.data.trifr
      console.log('input values',model)
  this._safetyConfigService.UpdateIncidentType(model).subscribe(res =>{
   
    if(res.m_Item1=true){
      console.log('result', res)
      this.DialogClose();
     
  
    }});
  
  }
  
  getincidenttypelist(){
    this._safetyConfigService.Get().subscribe(res=>{ 
      this.incidentList=res;
    
  
  
      this.incidentList.map(x=>{
        if(x.ID==this.data.IncId)
        {
          this.selectedName=x.Name
          this.selectedDescription=x.Description
          console.log( "after",this.selectedName)
        }
      })
  
    })
  }
  
  }
  